module.exports = __webpack_public_path__ + "img/Battery.290c1c12.png";